module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC7SURBVHgB3VLbDcIwDLw0GaAbAHNUipiBf9QRYANgEx4DMANdBJiATkCxE1UKJqRq+9eToiT23VlxDCRgT7jzSnFMKgmFOTqQYSSmZkAdL+0ZTUG7JBY+9yLOJowbYZejAbTCkQRfYo65i0YdSpSsZC/YkckeMVC8KnEIQ1pynlfcZit3XHaJowZRkz9ihmpHlQgLmXTPebvcj7jVmdS4Vut4VV/a60bPgeK/pT3HMDwyatCWD+iPmpv7AaUtNjem8lV+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icodescarga.png
// module id = es7E
// module chunks = 1